export default __webpack_public_path__ + "static/media/solutionEngineering.c8007b9d.png";